export function closeInfoPopup() {
    var infoPopup = document.querySelector('.infoPopup');
    var infoPopupClose = document.querySelector('.infoPopup__close');

    function isExpired(timestamp) {
        var oneWeek = 7 * 24 * 60 * 60 * 1000;
        var now = Date.now();
        return now - timestamp > oneWeek;
    }

    var modalClosedData = localStorage.getItem('infoPopupClosed');
    var modalShouldBeVisible = true;

    if (modalClosedData) {
        var modalClosedTimestamp = parseInt(modalClosedData, 10);

        if (!isNaN(modalClosedTimestamp)) {
            if (!isExpired(modalClosedTimestamp)) {
                modalShouldBeVisible = false;
            } else {
                localStorage.removeItem('infoPopupClosed');
            }
        }
    }

    if (infoPopup && infoPopupClose) {
        infoPopup.classList.remove('is-hidden');

        if (modalShouldBeVisible) {
            requestAnimationFrame(function() {
                var infoPopupHeight = infoPopup.scrollHeight + 'px';
                infoPopup.style.maxHeight = infoPopupHeight;
                infoPopup.style.marginBottom = '130px';
                infoPopup.style.marginTop = '130px';
            });

            infoPopupClose.addEventListener('click', function() {
                infoPopup.style.maxHeight = '0';
                infoPopup.style.marginBottom = '0';
                infoPopup.style.marginTop = '0';

                infoPopup.addEventListener('transitionend', function(e) {
                    if (e.propertyName === 'max-height') {
                        infoPopup.style.display = 'none';
                    }
                }, { once: true });

                var timestamp = Date.now();
                localStorage.setItem('infoPopupClosed', timestamp.toString());
            });
        } else {
            infoPopup.style.display = 'none';
        }
    }
}
